// murphy-bed-builder.js (UPDATED)
// Update: Lower Base Doors overlays now use `.lower-door-assets` dataset (no cabinet-style-group needed)
// Expects these preview IDs in Liquid:
//   <img id="overlay-lower-left"  ...>
//   <img id="overlay-lower-right" ...>
//
// Expects this hidden holder in Liquid:
// <div class="lower-door-assets"
//   data-left-flat="..."
//   data-right-flat="..."
//   data-left-shaker="..."
//   data-right-shaker="..."></div>

document.addEventListener("DOMContentLoaded", function () {
  const ENDPOINT = "https://project-ih3nu.vercel.app/api/create-draft-order";
  const BM_LINK = "https://www.benjaminmoore.com/en-us/paint-colors/search";
  const STAIN_LINK = "https://murphybedplace.com/pages/stains";

  /* ---------- PREVIEW ELEMENTS ---------- */
  const overlayDoor = document.getElementById("overlay-door");
  const overlayCrown = document.getElementById("overlay-crown");
  const overlayCabinetLeft = document.getElementById("overlay-cabinet-left");
  const overlayCabinetRight = document.getElementById("overlay-cabinet-right");
  const overlayUpperLeft = document.getElementById("overlay-upper-left");
  const overlayUpperRight = document.getElementById("overlay-upper-right");
  const overlayDrawersLeft = document.getElementById("overlay-drawers-left");
  const overlayDrawersRight = document.getElementById("overlay-drawers-right");

  // NEW: Lower base doors overlays
  const overlayLowerLeft = document.getElementById("overlay-lower-left");
  const overlayLowerRight = document.getElementById("overlay-lower-right");

  // NEW: Lower base door assets holder
  const lowerDoorAssets = document.querySelector(".lower-door-assets");

  /* ---------- PRICE UI ---------- */
  const basePriceEl = document.getElementById("base-price");
  const addonsPriceEl = document.getElementById("addons-price");
  const totalPriceEl = document.getElementById("total-price");

  /* ---------- HIDDEN FIELDS ---------- */
  const sizeField = document.getElementById("size-field");
  const doorField = document.getElementById("door-field");
  const crownField = document.getElementById("crown-field");
  const leftSideField = document.getElementById("left-side-field");
  const rightSideField = document.getElementById("right-side-field");
  const finishField = document.getElementById("finish-field");
  const colorField = document.getElementById("color-field");
  const mattressField = document.getElementById("mattress-field");
  const lightsField = document.getElementById("lights-field");
  const addonsField = document.getElementById("addons-field");
  const totalPriceField = document.getElementById("total-price-field");

  // Hidden paint fields from Liquid
  const paintColorNameField = document.getElementById("paint-color-name-field");
  const paintColorCodeField = document.getElementById("paint-color-code-field");
  const paintSourceField = document.getElementById("paint-source-field");

  /* ---------- CONTROLS ---------- */
  const sizeRadios = document.querySelectorAll('.size-option input[type="radio"]');
  const doorCards = document.querySelectorAll(".door-option");
  const crownRadios = document.querySelectorAll('.crown-option input[type="radio"]');
  const colorSwatches = document.querySelectorAll(".color-option");

  const leftToggle = document.querySelector('.side-enable[data-side="left"]');
  const rightToggle = document.querySelector('.side-enable[data-side="right"]');

  const leftAddonsBox = document.querySelector(".side-addons.left");
  const rightAddonsBox = document.querySelector(".side-addons.right");

  const leftDrawerGroup = document.querySelector(".drawer-style-group.left");
  const rightDrawerGroup = document.querySelector(".drawer-style-group.right");
  const leftUpperGroup = document.querySelector(".upper-style-group.left");
  const rightUpperGroup = document.querySelector(".upper-style-group.right");

  // Hidden holders for base cabinet images
  const hiddenLeftCabinet = document.querySelector(".cabinet-option:not(.second)");
  const hiddenRightCabinet = document.querySelector(".cabinet-option.second");

  const finishRadios = document.querySelectorAll('.finish-option input[type="radio"]');
  const mattressRadios = document.querySelectorAll('.mattress-options input[type="radio"]');
  const lightsCheckbox = document.getElementById("lights");

  /* ---------- BENJAMIN MOORE BLOCK ---------- */
  const bmBlock = document.querySelector(".bm-paint-picker");
  const bmPresetRadios = bmBlock ? bmBlock.querySelectorAll('input[name="bm-color"]') : [];
  const bmNameInput = bmBlock ? bmBlock.querySelector("#bm-custom-name") : null;
  const bmCodeInput = bmBlock ? bmBlock.querySelector("#bm-custom-code") : null;

  /* ---------- STAIN BLOCK ---------- */
  const stainBlock = document.querySelector(".stain-picker");
  // IMPORTANT: match your Liquid IDs: stain-custom-name / stain-custom-code
  const stainNameInput = stainBlock ? stainBlock.querySelector("#stain-custom-name") : null;
  const stainCodeInput = stainBlock ? stainBlock.querySelector("#stain-custom-code") : null;

  /* ---------- STATE ---------- */
  const num = (v) => (isNaN(parseFloat(v)) ? 0 : parseFloat(v));

  let state = {
    // base / size
    size: "Single",
    sizePrice: 2695,

    // door
    doorName: "Flat Modern",
    doorUpcharge: 0,

    // crown
    crownName: "No Crown",
    crownPrice: 0,

    // global color swatch
    color: "default",

    // sides
    leftEnabled: false,
    leftBase: 795,
    leftAddons: {
      'Left: Make 22" Wide': false,
      'Left: Add Two Drawers': false,
      'Left: Add Upper Door': false,
      'Left: Pull-Out Tray': false
    },

    rightEnabled: false,
    rightBase: 795,
    rightAddons: {
      'Right: Make 22" Wide': false,
      'Right: Add Two Drawers': false,
      'Right: Add Upper Doors': false,
      'Right: Pull-Out Tray': false
    },

    // finish
    finish: "",

    // lights
    lights: false,
    lightsPrice: 350,

    // mattress
    mattressName: "Siesta Mattress",
    mattressPrice: 0,

    // paint specific state
    paintMode: "swatch", // "swatch" | "bm-preset" | "bm-custom"
    paintPreset: "",
    paintCustomName: "",
    paintCustomCode: "",

    // stain specific state
    stainName: "",
    stainCode: ""
  };

  /* ---------- HELPERS ---------- */
  const getChecked = (sel) => document.querySelector(sel + ":checked");

  const getDrawerStyleEl = (side) => getChecked(`.drawer-style-group.${side} input[type="radio"]`);
  const getUpperStyleEl = (side) => getChecked(`.upper-style-group.${side} input[type="radio"]`);

  function imgFromDatasetByColor(el, sidePrefix) {
    if (!el) return "";
    const c = state.color;

    const key =
      sidePrefix === "left"
        ? c === "black"
          ? "leftBlack"
          : c === "white"
          ? "leftWhite"
          : c === "beige"
          ? "leftBeige"
          : c === "woodbrown"
          ? "leftWoodbrown"
          : "leftDefault"
        : c === "black"
        ? "rightBlack"
        : c === "white"
        ? "rightWhite"
        : c === "beige"
        ? "rightBeige"
        : c === "woodbrown"
        ? "rightWoodbrown"
        : "rightDefault";

    return (el.dataset && el.dataset[key]) ? el.dataset[key] : "";
  }

  function getCrownSrc(crownRadio) {
    if (!crownRadio) return "";

    let placement = "door";
    if (state.leftEnabled && state.rightEnabled) placement = "full";
    else if (state.leftEnabled) placement = "left";
    else if (state.rightEnabled) placement = "right";

    const colorKey =
      state.color === "black"
        ? "Black"
        : state.color === "white"
        ? "White"
        : state.color === "beige"
        ? "Beige"
        : state.color === "woodbrown"
        ? "Woodbrown"
        : "Default";

    const map = {
      doorDefault: crownRadio.dataset.doorDefault,
      doorBlack: crownRadio.dataset.doorBlack,
      doorWhite: crownRadio.dataset.doorWhite,
      doorBeige: crownRadio.dataset.doorBeige,
      doorWoodbrown: crownRadio.dataset.doorWoodbrown,

      leftDefault: crownRadio.dataset.leftDefault,
      leftBlack: crownRadio.dataset.leftBlack,
      leftWhite: crownRadio.dataset.leftWhite,
      leftBeige: crownRadio.dataset.leftBeige,
      leftWoodbrown: crownRadio.dataset.leftWoodbrown,

      rightDefault: crownRadio.dataset.rightDefault,
      rightBlack: crownRadio.dataset.rightBlack,
      rightWhite: crownRadio.dataset.rightWhite,
      rightBeige: crownRadio.dataset.rightBeige,
      rightWoodbrown: crownRadio.dataset.rightWoodbrown,

      fullDefault: crownRadio.dataset.fullDefault,
      fullBlack: crownRadio.dataset.fullBlack,
      fullWhite: crownRadio.dataset.fullWhite,
      fullBeige: crownRadio.dataset.fullBeige,
      fullWoodbrown: crownRadio.dataset.fullWoodbrown
    };

    const key = (placement + colorKey).replace(/-/, "");
    return map[key] || "";
  }

  function getLowerDoorVariant() {
    // Flat is default
    const selectedDoor = document.querySelector(".door-option.selected");
    const name = (selectedDoor && selectedDoor.dataset && selectedDoor.dataset.value ? selectedDoor.dataset.value : "")
      .toLowerCase();

    // These door styles should use the shaker lower door assets
    if (name.includes("shaker") || name.includes("rockland") || name.includes("douglas")) return "shaker";
    return "flat";
  }

  function lowerDoorSrc(side) {
    if (!lowerDoorAssets) return "";

    const variant = getLowerDoorVariant(); // "flat" | "shaker"
    // dataset keys in HTML: leftFlat, rightFlat, leftShaker, rightShaker
    const key =
      side === "left"
        ? variant === "shaker"
          ? "leftShaker"
          : "leftFlat"
        : variant === "shaker"
        ? "rightShaker"
        : "rightFlat";

    return (lowerDoorAssets.dataset && lowerDoorAssets.dataset[key]) ? lowerDoorAssets.dataset[key] : "";
  }

  /* ---------- IMAGE SWITCHERS ---------- */
  function updateDoorImage() {
    const selected = document.querySelector(".door-option.selected");
    if (!selected || !overlayDoor) return;

    const src =
      state.color === "black"
        ? selected.dataset.imageBlack
        : state.color === "white"
        ? selected.dataset.imageWhite
        : state.color === "beige"
        ? selected.dataset.imageBeige
        : state.color === "woodbrown"
        ? selected.dataset.imageWoodbrown
        : selected.dataset.imageDefault;

    if (src) {
      overlayDoor.src = src;
      overlayDoor.style.display = "block";
    } else {
      overlayDoor.style.display = "none";
    }
  }

  function updateCrownImage() {
    if (!overlayCrown) return;

    const r = getChecked('.crown-option input[type="radio"]');
    if (!r || r.value === "No Crown") {
      overlayCrown.style.display = "none";
      return;
    }

    const src = getCrownSrc(r);
    if (src) {
      overlayCrown.src = src;
      overlayCrown.style.display = "block";
    } else {
      overlayCrown.style.display = "none";
    }
  }

  function updateCabinetBaseSide(side) {
    const enabled = side === "left" ? state.leftEnabled : state.rightEnabled;
    const container = side === "left" ? overlayCabinetLeft : overlayCabinetRight;

    if (!container) return;

    if (!enabled) {
      container.style.display = "none";
      return;
    }

    const holder = side === "left" ? hiddenLeftCabinet : hiddenRightCabinet;
    const src = imgFromDatasetByColor(holder, side);

    if (src) {
      container.src = src;
      container.style.display = "block";
    } else {
      container.style.display = "none";
    }
  }

  // NEW: Lower base doors overlay (uses `.lower-door-assets`)
  function updateLowerDoorImageSide(side) {
    const enabled = side === "left" ? state.leftEnabled : state.rightEnabled;
    const container = side === "left" ? overlayLowerLeft : overlayLowerRight;

    if (!container) return;

    // If no side cabinet, no lower doors overlay
    if (!enabled) {
      container.style.display = "none";
      return;
    }

    const src = lowerDoorSrc(side);
    if (src) {
      container.src = src;
      container.style.display = "block";
    } else {
      container.style.display = "none";
    }
  }

  function updateUpperImageSide(side) {
    const addonOn =
      side === "left" ? state.leftAddons['Left: Add Upper Door'] : state.rightAddons['Right: Add Upper Doors'];

    const container = side === "left" ? overlayUpperLeft : overlayUpperRight;

    if (!container) return;

    if (!addonOn || !(side === "left" ? state.leftEnabled : state.rightEnabled)) {
      container.style.display = "none";
      return;
    }

    const styleEl = getUpperStyleEl(side);
    const src = imgFromDatasetByColor(styleEl, side);

    if (src) {
      container.src = src;
      container.style.display = "block";
    } else {
      container.style.display = "none";
    }
  }

  function updateDrawerImageSide(side) {
    const addonOn =
      side === "left" ? state.leftAddons['Left: Add Two Drawers'] : state.rightAddons['Right: Add Two Drawers'];

    const container = side === "left" ? overlayDrawersLeft : overlayDrawersRight;

    if (!container) return;

    if (!addonOn || !(side === "left" ? state.leftEnabled : state.rightEnabled)) {
      container.style.display = "none";
      return;
    }

    const styleEl = getDrawerStyleEl(side);
    const src = imgFromDatasetByColor(styleEl, side);

    if (src) {
      container.src = src;
      container.style.display = "block";
    } else {
      container.style.display = "none";
    }
  }

  function updateAllImages() {
    updateCabinetBaseSide("left");
    updateCabinetBaseSide("right");

    // Lower doors update after cabinet base
    updateLowerDoorImageSide("left");
    updateLowerDoorImageSide("right");

    updateUpperImageSide("left");
    updateUpperImageSide("right");
    updateDrawerImageSide("left");
    updateDrawerImageSide("right");

    updateDoorImage();
    updateCrownImage();
  }

  /* ---------- PRICING ---------- */
  function sidesTotal() {
    let t = 0;

    // NOTE: Your HTML has Pull-Out Tray data-price="200"
    // If you want Pull-Out Tray to be FREE, set data-price="0" in Liquid.
    // Here we keep pricing consistent with your state summary logic (currently +$0 in your code).
    const leftTrayPrice = 200;
    const rightTrayPrice = 200;

    if (state.leftEnabled) {
      t += state.leftBase;
      if (state.leftAddons['Left: Make 22" Wide']) t += 200;
      if (state.leftAddons['Left: Add Two Drawers']) t += 200;
      if (state.leftAddons['Left: Add Upper Door']) t += 250;
      if (state.leftAddons['Left: Pull-Out Tray']) t += leftTrayPrice;
    }

    if (state.rightEnabled) {
      t += state.rightBase;
      if (state.rightAddons['Right: Make 22" Wide']) t += 200;
      if (state.rightAddons['Right: Add Two Drawers']) t += 200;
      if (state.rightAddons['Right: Add Upper Doors']) t += 250;
      if (state.rightAddons['Right: Pull-Out Tray']) t += rightTrayPrice;
    }

    return t;
  }

  function preFinishSubtotal() {
    return (
      state.sizePrice +
      state.doorUpcharge +
      state.crownPrice +
      sidesTotal() +
      state.mattressPrice +
      (state.lights ? state.lightsPrice : 0)
    );
  }

  function finishCharge(pre) {
    if (state.finish === "Stained and Lacquer") return 0;
    if (state.finish === "Paint") return pre * 0.05;
    return 0;
  }

  function currentPaintDescription() {
    if (state.finish !== "Paint") return "";
    if (state.paintMode === "bm-preset" && state.paintPreset) return state.paintPreset;

    if (state.paintMode === "bm-custom" && (state.paintCustomName || state.paintCustomCode)) {
      const name = state.paintCustomName || "Custom";
      const code = state.paintCustomCode ? ` (${state.paintCustomCode})` : "";
      return `${name}${code}`;
    }

    return `Paint (${state.color})`;
  }

  function currentStainDescription() {
    if (state.finish !== "Stained and Lacquer") return "";
    if (state.stainName || state.stainCode) {
      const name = state.stainName || "Custom Stain";
      const code = state.stainCode ? ` (${state.stainCode})` : "";
      return `${name}${code}`;
    }
    return `Stain (${state.color})`;
  }

  function updateTotals() {
    const pre = preFinishSubtotal();
    const fin = finishCharge(pre);

    const addOnsShown =
      state.doorUpcharge +
      state.crownPrice +
      sidesTotal() +
      state.mattressPrice +
      (state.lights ? state.lightsPrice : 0) +
      fin;

    const grand = state.sizePrice + addOnsShown;

    if (basePriceEl) basePriceEl.textContent = state.sizePrice.toFixed(0);
    if (addonsPriceEl) addonsPriceEl.textContent = addOnsShown.toFixed(0);
    if (totalPriceEl) totalPriceEl.textContent = grand.toFixed(0);
    if (totalPriceField) totalPriceField.value = `$${grand.toFixed(2)}`;

    // hidden fields
    if (sizeField) sizeField.value = state.size;
    if (doorField) doorField.value = state.doorName;
    if (crownField) crownField.value = state.crownName;

    const leftSummary = state.leftEnabled
      ? [
          "Base $" + state.leftBase,
          state.leftAddons['Left: Make 22" Wide'] ? '22" Wide (+$200)' : null,
          state.leftAddons['Left: Add Two Drawers']
            ? `Drawers: ${(getDrawerStyleEl("left") && getDrawerStyleEl("left").value) || "style"} (+$200)`
            : null,
          state.leftAddons['Left: Add Upper Door']
            ? `Upper: ${(getUpperStyleEl("left") && getUpperStyleEl("left").value) || "style"} (+$250)`
            : null,
          state.leftAddons['Left: Pull-Out Tray'] ? "Pull-Out Tray (+$200)" : null
        ]
          .filter(Boolean)
          .join(", ")
      : "None";

    const rightSummary = state.rightEnabled
      ? [
          "Base $" + state.rightBase,
          state.rightAddons['Right: Make 22" Wide'] ? '22" Wide (+$200)' : null,
          state.rightAddons['Right: Add Two Drawers']
            ? `Drawers: ${(getDrawerStyleEl("right") && getDrawerStyleEl("right").value) || "style"} (+$200)`
            : null,
          state.rightAddons['Right: Add Upper Doors']
            ? `Upper: ${(getUpperStyleEl("right") && getUpperStyleEl("right").value) || "style"} (+$250)`
            : null,
          state.rightAddons['Right: Pull-Out Tray'] ? "Pull-Out Tray (+$200)" : null
        ]
          .filter(Boolean)
          .join(", ")
      : "None";

    if (leftSideField) leftSideField.value = leftSummary;
    if (rightSideField) rightSideField.value = rightSummary;

    if (finishField) finishField.value = state.finish || "None";

    // color field logic & paint / stain extra fields
    if (state.finish === "Paint") {
      const desc = currentPaintDescription();
      if (colorField) colorField.value = desc ? `Paint (Benjamin Moore / Custom): ${desc}` : "Paint (no color selected)";

      if (paintColorNameField || paintColorCodeField || paintSourceField) {
        if (state.paintMode === "bm-preset" && state.paintPreset) {
          const match = state.paintPreset.match(/^(.*)\((.*)\)\s*$/);
          if (match) {
            if (paintColorNameField) paintColorNameField.value = match[1].trim();
            if (paintColorCodeField) paintColorCodeField.value = match[2].trim();
          } else {
            if (paintColorNameField) paintColorNameField.value = state.paintPreset;
            if (paintColorCodeField) paintColorCodeField.value = "";
          }
        } else if (state.paintMode === "bm-custom") {
          if (paintColorNameField) paintColorNameField.value = state.paintCustomName || "";
          if (paintColorCodeField) paintColorCodeField.value = state.paintCustomCode || "";
        } else {
          if (paintColorNameField) paintColorNameField.value = "";
          if (paintColorCodeField) paintColorCodeField.value = "";
        }
        if (paintSourceField) paintSourceField.value = BM_LINK;
      }
    } else if (state.finish === "Stained and Lacquer") {
      const desc = currentStainDescription();
      if (colorField) colorField.value = desc ? `Wood Stain: ${desc}` : "Wood Stain (no code entered)";

      if (paintColorNameField) paintColorNameField.value = "";
      if (paintColorCodeField) paintColorCodeField.value = "";
      if (paintSourceField) paintSourceField.value = "";
    } else {
      if (colorField) colorField.value = state.color;
      if (paintColorNameField) paintColorNameField.value = "";
      if (paintColorCodeField) paintColorCodeField.value = "";
      if (paintSourceField) paintSourceField.value = "";
    }

    if (mattressField) mattressField.value = state.mattressName;
    if (lightsField) lightsField.value = state.lights ? "Yes (+$350)" : "No";

    const addons = [];

    if (state.doorUpcharge) addons.push(`Door: ${state.doorName} (+$${state.doorUpcharge})`);
    else addons.push(`Door: ${state.doorName} (Included)`);

    addons.push(`Crown: ${state.crownName}` + (state.crownName === "No Crown" ? "" : ` (+$${state.crownPrice})`));

    if (state.leftEnabled) addons.push(`Left Side: ${leftSummary}`);
    if (state.rightEnabled) addons.push(`Right Side: ${rightSummary}`);

    if (state.finish === "Paint") {
      addons.push("Finish: Paint (+5%)");
      const paintDesc = currentPaintDescription();
      if (paintDesc) {
        addons.push(`Paint Color: ${paintDesc}`);
        addons.push(`Paint Link: ${BM_LINK}`);
      }
    } else if (state.finish === "Stained and Lacquer") {
      addons.push("Finish: Stained and Lacquer (Included)");
      const stainDesc = currentStainDescription();
      if (stainDesc) {
        addons.push(`Stain: ${stainDesc}`);
        addons.push(`Stain Link: ${STAIN_LINK}`);
      }
    }

    if (state.mattressName) {
      addons.push(`Mattress: ${state.mattressName}` + (state.mattressPrice ? ` (+$${state.mattressPrice})` : ""));
    }
    if (state.lights) addons.push("Lights (+$350)");

    if (addonsField) addonsField.value = addons.join(" | ");
  }

  function refresh() {
    updateAllImages();
    updateTotals();
  }

  /* ---------- TOGGLE HELPERS ---------- */
  function toggleBmBlock(show) {
    if (!bmBlock) return;
    bmBlock.classList.toggle("is-active", !!show);
  }

  function toggleStainBlock(show) {
    if (!stainBlock) return;
    stainBlock.classList.toggle("is-active", !!show);
  }

  function clearBmSelections() {
    if (bmPresetRadios && bmPresetRadios.length) bmPresetRadios.forEach((r) => (r.checked = false));
    if (bmNameInput) bmNameInput.value = "";
    if (bmCodeInput) bmCodeInput.value = "";
    state.paintMode = "swatch";
    state.paintPreset = "";
    state.paintCustomName = "";
    state.paintCustomCode = "";
  }

  function clearStainSelections() {
    state.stainName = "";
    state.stainCode = "";
    if (stainNameInput) stainNameInput.value = "";
    if (stainCodeInput) stainCodeInput.value = "";
  }

  /* ---------- EVENTS ---------- */

  // Size
  sizeRadios.forEach((r) =>
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.size = r.value;
      state.sizePrice = num(r.dataset.price);
      refresh();
    })
  );

  // Doors
  doorCards.forEach((card) => {
    card.addEventListener("click", () => {
      doorCards.forEach((c) => c.classList.remove("selected"));
      card.classList.add("selected");
      state.doorName = card.dataset.value || "Door";
      state.doorUpcharge = num(card.dataset.price || 0);
      refresh(); // this refresh will also update lower doors via getLowerDoorVariant()
    });
  });

  // Crown
  crownRadios.forEach((r) =>
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.crownName = r.value;
      state.crownPrice = num(r.dataset.price || 0);
      refresh();
    })
  );

  // Global Color (swatches)
  colorSwatches.forEach((sw) =>
    sw.addEventListener("click", () => {
      colorSwatches.forEach((s) => s.classList.remove("active"));
      sw.classList.add("active");
      state.color = sw.dataset.color || "default";
      refresh();
    })
  );

  // Enable/disable sides
  if (leftToggle) {
    leftToggle.addEventListener("change", () => {
      state.leftEnabled = !!leftToggle.checked;
      if (leftAddonsBox) leftAddonsBox.style.display = state.leftEnabled ? "block" : "none";
      refresh();
    });
  }

  if (rightToggle) {
    rightToggle.addEventListener("change", () => {
      state.rightEnabled = !!rightToggle.checked;
      if (rightAddonsBox) rightAddonsBox.style.display = state.rightEnabled ? "block" : "none";
      refresh();
    });
  }

  // Side addon checkboxes
  document.querySelectorAll(".side-addon").forEach((chk) => {
    chk.addEventListener("change", () => {
      const side = chk.dataset.side;
      const name = chk.dataset.name;

      if (side === "left") state.leftAddons[name] = !!chk.checked;
      else state.rightAddons[name] = !!chk.checked;

      if (chk.classList.contains("toggle-drawer")) {
        const g = side === "left" ? leftDrawerGroup : rightDrawerGroup;
        if (g) g.style.display = chk.checked ? "block" : "none";
      }

      if (chk.classList.contains("toggle-upper")) {
        const g = side === "left" ? leftUpperGroup : rightUpperGroup;
        if (g) g.style.display = chk.checked ? "block" : "none";
      }

      refresh();
    });
  });

  // Drawer/Upper style radios
  document
    .querySelectorAll(".drawer-style-group input[type='radio'], .upper-style-group input[type='radio']")
    .forEach((r) => r.addEventListener("change", refresh));

  // Finish
  finishRadios.forEach((r) =>
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.finish = r.value;

      if (state.finish === "Paint") {
        toggleBmBlock(true);
        toggleStainBlock(false);
      } else if (state.finish === "Stained and Lacquer") {
        toggleBmBlock(false);
        toggleStainBlock(true);
        clearBmSelections();
      } else {
        toggleBmBlock(false);
        toggleStainBlock(false);
        clearBmSelections();
        clearStainSelections();
      }

      refresh();
    })
  );

  // Mattress
  mattressRadios.forEach((r) =>
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.mattressName = r.value;
      state.mattressPrice = num(r.dataset.price || 0);
      refresh();
    })
  );

  // Lights
  if (lightsCheckbox) {
    lightsCheckbox.addEventListener("change", () => {
      state.lights = !!lightsCheckbox.checked;
      refresh();
    });
  }

  // BM preset radios
  if (bmPresetRadios && bmPresetRadios.length) {
    bmPresetRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (!radio.checked) return;
        state.paintMode = "bm-preset";
        state.paintPreset = radio.value;

        if (bmNameInput) bmNameInput.value = "";
        if (bmCodeInput) bmCodeInput.value = "";
        state.paintCustomName = "";
        state.paintCustomCode = "";
        refresh();
      });
    });
  }

  // BM custom name
  if (bmNameInput) {
    bmNameInput.addEventListener("input", () => {
      state.paintMode = "bm-custom";
      state.paintCustomName = bmNameInput.value.trim();
      if (bmPresetRadios && bmPresetRadios.length) bmPresetRadios.forEach((r) => (r.checked = false));
      refresh();
    });
  }

  // BM custom code
  if (bmCodeInput) {
    bmCodeInput.addEventListener("input", () => {
      state.paintMode = "bm-custom";
      state.paintCustomCode = bmCodeInput.value.trim();
      if (bmPresetRadios && bmPresetRadios.length) bmPresetRadios.forEach((r) => (r.checked = false));
      refresh();
    });
  }

  // Stain custom name
  if (stainNameInput) {
    stainNameInput.addEventListener("input", () => {
      state.stainName = stainNameInput.value.trim();
      refresh();
    });
  }

  // Stain custom code
  if (stainCodeInput) {
    stainCodeInput.addEventListener("input", () => {
      state.stainCode = stainCodeInput.value.trim();
      refresh();
    });
  }

  /* ---------- DEFAULTS FROM DOM ---------- */
  const sizeDefault = getChecked('.size-option input[type="radio"]');
  if (sizeDefault) {
    state.size = sizeDefault.value;
    state.sizePrice = num(sizeDefault.dataset.price || state.sizePrice);
  }

  // Door default: keep existing selected if present, else first
  const alreadySelectedDoor = document.querySelector(".door-option.selected");
  if (alreadySelectedDoor) {
    state.doorName = alreadySelectedDoor.dataset.value || "Door";
    state.doorUpcharge = num(alreadySelectedDoor.dataset.price || 0);
  } else if (doorCards.length) {
    doorCards[0].classList.add("selected");
    state.doorName = doorCards[0].dataset.value || "Flat Modern";
    state.doorUpcharge = num(doorCards[0].dataset.price || 0);
  }

  // Default color active
  if (colorSwatches.length) {
    const activeSwatch = document.querySelector(".color-option.active");
    if (activeSwatch && activeSwatch.dataset.color) state.color = activeSwatch.dataset.color;
    else {
      colorSwatches[0].classList.add("active");
      state.color = colorSwatches[0].dataset.color || "default";
    }
  }

  const crownDefault = getChecked('.crown-option input[type="radio"]');
  if (crownDefault) {
    state.crownName = crownDefault.value;
    state.crownPrice = num(crownDefault.dataset.price || 0);
  }

  const finishDefault = getChecked('.finish-option input[type="radio"]');
  if (finishDefault) {
    state.finish = finishDefault.value;
    if (state.finish === "Paint") {
      toggleBmBlock(true);
      toggleStainBlock(false);
    } else if (state.finish === "Stained and Lacquer") {
      toggleBmBlock(false);
      toggleStainBlock(true);
    }
  }

  // IMPORTANT: Init side enables from DOM on load (fixes your lower doors not showing if toggles are pre-checked)
  if (leftToggle) {
    state.leftEnabled = !!leftToggle.checked;
    if (leftAddonsBox) leftAddonsBox.style.display = state.leftEnabled ? "block" : "none";
  }
  if (rightToggle) {
    state.rightEnabled = !!rightToggle.checked;
    if (rightAddonsBox) rightAddonsBox.style.display = state.rightEnabled ? "block" : "none";
  }

  refresh();

  /* ---------- SUBMIT ---------- */
  async function createDraftOrder(total) {
    const props = {
      Size: sizeField ? sizeField.value : "",
      Door: doorField ? doorField.value : "",
      Crown: crownField ? crownField.value : "",
      "Left Side": leftSideField ? leftSideField.value : "",
      "Right Side": rightSideField ? rightSideField.value : "",
      Finish: finishField ? finishField.value : "",
      Color: colorField ? colorField.value : "",
      Mattress: mattressField ? mattressField.value : "",
      Lights: lightsField ? lightsField.value : "",
      "Addons Summary": addonsField ? addonsField.value : "",
      "Calculated Price": totalPriceField ? totalPriceField.value : `$${num(total).toFixed(2)}`
    };

    if (state.finish === "Paint") {
      props["Paint Mode"] = state.paintMode;

      if (state.paintMode === "bm-preset" && state.paintPreset) {
        props["Paint Selection"] = state.paintPreset;
      }

      if (state.paintMode === "bm-custom" && (state.paintCustomName || state.paintCustomCode)) {
        props["Paint Custom Name"] = state.paintCustomName || "";
        props["Paint Custom Code"] = state.paintCustomCode || "";
      }

      props["Paint Color Library"] = BM_LINK;
    }

    if (state.finish === "Stained and Lacquer") {
      if (state.stainName || state.stainCode) {
        props["Stain Name"] = state.stainName || "";
        props["Stain Code"] = state.stainCode || "";
      }
      props["Stain Library"] = STAIN_LINK;
    }

    const payload = {
      title: "Murphy Bed (Customizable)",
      price: num(total),
      quantity: 1,
      properties: props
    };

    const r = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await r.json().catch(() => ({}));
    if (!r.ok || !data || data.ok !== true) {
      throw new Error(data && data.error ? data.error : "Draft order API failed.");
    }
    return data.invoice_url;
  }

  function setLoading(b) {
    const btn = document.querySelector("#murphy-form button[type='submit']");
    if (!btn) return;

    if (b) {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.textContent = "Please wait…";
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || "Add to Cart";
    }
  }

  const form = document.querySelector("#murphy-form");
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const pre = preFinishSubtotal();
      const fin = finishCharge(pre);
      const total =
        state.sizePrice +
        state.doorUpcharge +
        state.crownPrice +
        sidesTotal() +
        state.mattressPrice +
        (state.lights ? state.lightsPrice : 0) +
        fin;

      if (totalPriceField) totalPriceField.value = `$${total.toFixed(2)}`;

      try {
        setLoading(true);
        const url = await createDraftOrder(total);
        window.location.href = url;
      } catch (err) {
        console.error(err);
        alert("Could not create checkout. " + (err.message || err));
      } finally {
        setLoading(false);
      }
    });
  }
});
